<span class="bar-line">
  <span class="immutable-chartjs-style" [style.height.px]="size">
    <canvas
      baseChart
      [type]="_chartType"
      [data]="_data$ | async"
      [options]="_options$ | async"
      [plugins]="plugins"
    >
    </canvas>
  </span>
</span>

@if (displayLegend && _legendItems) {
  <myre-chart-legend
    [items]="_legendItems"
    [chart]="_chartDirective?.chart"
    [canToggleDataVisibility]="false"
    modeLinkingHover="none"
  />
}
